var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-button',{attrs:{"plain":true},on:{"click":_vm.open6}},[_vm._v("success")]),_c('el-button',{attrs:{"plain":true},on:{"click":_vm.open8}},[_vm._v("error")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }